import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "app-breadcrumb-item",
  imports: [],
  templateUrl: "./breadcrumb-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbItemComponent {
  title = input.required<string>();
}
